import { TimeTracking } from '@work4all/models/lib/Classes/TimeTracking.entity';

import { useTimeTrackingMaskActions } from '../../../time-tracking-mask/hooks';
import { EntityTableLayoutV8Props } from '../../table/EntityTableLayoutV8';

type Return = EntityTableLayoutV8Props['actions'];

export const useProjectHoursTableActions = (
  records: TimeTracking[] | undefined
): Return => {
  return useTimeTrackingMaskActions(records?.[0]);
};
